import {remCalc} from '_themeUtils'

const NewsletterModalStep3 = {
    NewsletterModal_step_3: {
        baseStyle: () => ({
            containerstep_3: {
                h: {base: '100%'},
            },
            titleWrapperThankyou: {
                textStyle: {base: 'displayXs', md: 'displaySm'},
                fontWeight: 400,
                mt: {base: `spacing.5`},
            },
            description: {
                color: 'color.text.grey.700',
                textStyle: 'paragraphSm',
                fontWeight: 400,
                lineHeight: remCalc(18),
                mb: {base: `spacing.8`},
                mt: 'spacing.2',
            },
            buttonsWrapper: {
                flexDirection: 'column',
                alignItems: 'center',
                pb: 'spacing.8',
            },
            button: {
                alignSelf: 'center',
                w: '100%',
                textTransform: 'uppercase',
                fontWeight: 400,
                letterSpacing: remCalc(3),
                h: remCalc(54),
            },
            buttonNotNow: {
                alignSelf: 'center',
                w: 'auto',
                textStyle: 'paragraphXs',
                textTransform: 'uppercase',
                mt: 'spacing.4',
                letterSpacing: remCalc(4),
                border: '1px solid transparent',
                borderBottomColor: 'color.border.black',
                _hover: {
                    borderTopColor: 'color.border.black',
                },
            },
        }),
    },
}

export default NewsletterModalStep3
